export default function () {
    return (
        <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="80" height="80" rx="40" fill="url(#paint0_linear_4806_12669)" />
            <g filter="url(#filter0_di_4806_12669)">
                <path
                    d="M37.6163 23.0861C42.4694 23.0861 46.4042 27.0202 46.4044 31.8732C46.4044 34.8551 44.9169 37.4874 42.6456 39.0763C47.399 41.0734 50.9015 45.8138 51.7941 51.4474C52.1741 53.8463 50.1645 55.6368 48.0245 55.6368H27.2091C25.0692 55.6367 23.0595 53.8463 23.4396 51.4474C24.332 45.8147 27.8336 41.0749 32.5861 39.0773C30.3154 37.4884 28.8292 34.8548 28.8292 31.8732C28.8295 27.0203 32.7635 23.0863 37.6163 23.0861ZM37.6173 40.6613C31.9548 40.6613 27.0375 45.3568 26.0079 51.8546C25.9224 52.3962 26.372 53.0362 27.2091 53.0363H48.0245C48.8617 53.0362 49.3113 52.3962 49.2257 51.8546C48.1962 45.357 43.2796 40.6615 37.6173 40.6613ZM54.8273 35.254H58.2072V37.8536H54.8273V41.2335H52.2277V37.8536H48.8478V35.254H52.2277V31.8741H54.8273V35.254ZM37.6163 25.6857C34.1994 25.6859 31.4291 28.4562 31.4288 31.8732C31.4288 35.2903 34.1992 38.0605 37.6163 38.0607C41.0336 38.0607 43.8038 35.2904 43.8038 31.8732C43.8036 28.4561 41.0335 25.6857 37.6163 25.6857Z"
                    fill="url(#paint1_linear_4806_12669)"
                />
            </g>
            <defs>
                <filter
                    id="filter0_di_4806_12669"
                    x="20.8931"
                    y="20.5861"
                    width="39.8141"
                    height="37.5508"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                    <feOffset />
                    <feGaussianBlur stdDeviation="1.25" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix type="matrix" values="0 0 0 0 0.972511 0 0 0 0 0.889864 0 0 0 0 0.703908 0 0 0 0.8 0" />
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_4806_12669" />
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_4806_12669" result="shape" />
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                    <feOffset dx="0.3" />
                    <feGaussianBlur stdDeviation="0.55" />
                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.66 0" />
                    <feBlend mode="normal" in2="shape" result="effect2_innerShadow_4806_12669" />
                </filter>
                <linearGradient id="paint0_linear_4806_12669" x1="13.232" y1="10.6479" x2="72.5096" y2="75.9879" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#714200" />
                    <stop offset="0.5" stopColor="#966A2C" />
                    <stop offset="1" stopColor="#714200" />
                </linearGradient>
                <linearGradient id="paint1_linear_4806_12669" x1="23.3927" y1="23.9049" x2="63.5782" y2="36.3985" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#FFF6E1" />
                    <stop offset="1" stopColor="#FFE4AC" />
                </linearGradient>
            </defs>
        </svg>
    );
}
